export enum RoutesEnum {
  ONBOARDING_LOGIN = '/onboarding/login',
  ONBOARDING_WELCOME = '/onboarding/welcome',
  ONBOARDING_TUTORIAL01 = '/onboarding/tutorial-01',
  ONBOARDING_TUTORIAL02 = '/onboarding/tutorial-02',
  ONBOARDING_TUTORIAL03 = '/onboarding/tutorial-03',
  ONBOARDING_TUTORIAL04 = '/onboarding/tutorial-04',
  ONBOARDING_SERVICES = '/onboarding/services',
  ONBOARDING_SHOP = '/onboarding/shop',
  ONBOARDING_FORBIDDEN = '/onboarding/forbidden',
  SERVICES = '/services',
  PLANNING = '/planning',
  SCHEDULES = '/schedules',
  PLANNING_DETAILS = '/planning-details',
  CALENDAR = '/calendar',
  TEST_MODE = '/test-mode',
  WIDGET = '/widget',
  CIS = '/cis',
  CIS_DETAILS = '/cis/details',
}
